import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import actions from "./actions.js";
import Cookies from 'js-cookie';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import { useNavigate } from "react-router-dom";

import { AppBar, Typography, Toolbar,Grid ,Card } from '@mui/material';

import { useDispatch, useSelector, useState } from "react-redux";

import "./css/header.css";

//const pages = ['About', 'Pricing'];
//const pages = ['Sign-in','About', 'Pricing'];
const pages = [];

//const settings = ['Profile', 'Notifications','Billing', 'Premium', 'Logout'];

const settings = ['Logout'];


function ResponsiveAppBar() {



  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const aboutPage = useSelector((state) => state.aboutPage);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (event) => {
  //  alert(event.currentTarget)
    //console.log(event.currentTarget);
    setAnchorElUser(null);
  };

  return (
    <AppBar sx={{ opacity:0.9 }} position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ opacity:0.8,flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

          <Button
            variant="contained"

            onClick={() => navigate("/flight-search") }
          //    onClick={() => addWhatsappNumber(val)}
          >
            <AirplanemodeActiveIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            sx={{

              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            METARAPP
          </Typography>

            </Button>
            </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"f
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) =>   (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                <Typography
                  onClick={() => {
                   if (page=="Pricing")
                   {
                     navigate("/pricing")
                   }else
                   if (page=="About")
                   {
                     navigate("/about-us")
                     dispatch({
                       type: actions.SET_ABOUT_SHOW
                     });
                   }
                   else if (page=="Sign-in")
                   {
                     dispatch({
                       type: actions.SET_ABOUT_HIDE
                     });
                     navigate("/")
                   }



                                         }}


                   textAlign="center">{page}</Typography>
                </MenuItem>
              )).filter(      (obj) => {
                    if (userInfo.result)
                    {
                      if (obj.key=="Sign-in")
                        return false;
                      else
                        return true;
                    }
                    else {
                        return 1;
                    }

              }  )

            }
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          <Button

            variant="contained"
            onClick={() => navigate("/flight-search") }
          //    onClick={() => addWhatsappNumber(val)}
          >
          <AirplanemodeActiveIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{

              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            METARPP
          </Typography>
          </Button>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) =>      (
             <Button
                key={page}
                onClick={() => {
                 if (page=="Pricing")
                 {
                   navigate("/pricing")
                 }else
                 if (page=="About")
                 {
                   navigate("/about-us")
                   dispatch({
                     type: actions.SET_ABOUT_SHOW
                   });

                 }
                 else if (page=="Sign-in")
                 {
                   dispatch({
                     type: actions.SET_ABOUT_HIDE
                   });
                   navigate("/")
                 }



                                       }}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            )).filter(      (obj) => {
                  if (userInfo.result)
                  {
                    if (obj.key=="Sign-in")
                      return false;
                    else
                      return true;
                  }
                  else {
                      return 1;
                  }

            }  )

          }
          </Box>

          { userInfo.result && <Box sx={{ flexGrow: 0 }}>

            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src={   userInfo.result && ( userInfo.result.picture )  } />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              { false && userInfo.result && (
                <Box sx={{ m: 2  ,fontWeight: 'medium', fontSize: 'small',  border: 1}} >
                <Typography       variant="subtitle"
                    color="green"
                    sx={{
                      mr: 2,
                      mx:1,
                      flexGrow: 1,
                      fontFamily: 'monospace',
                      fontWeight: 700,
                      color: 'green',
                      textDecoration: 'none',
                    }} >{ userInfo.result && ('CREDITS:'+userInfo.result.credits) }


                </Typography>
                </Box>)

              }
              {settings.map((setting) => (
                <MenuItem   key={setting}    onClick={() => {
                    if (setting=="Logout")
                    {
                          Cookies.remove('user');
                          navigate(0);
                      }
                    else
                      if (setting=="Billing")
                            navigate("/billing");

                    else
                      if (setting=="Profile")
                        navigate("/profile");
                      else
                      if (setting=="Premium")
                          alert("Coming soon...")
                          else
                          if (setting=="Notifications")
                              alert("Coming soon...")
                                    //navigate("/profile");



                          }}>

                  <Typography   variant="subtitle"

                    sx={{
                      color:"black",
                      fontWeight: 350,
                      textDecoration: 'none',
                    }} textAlign="center">{setting}</Typography>

                </MenuItem>
              ))}
            </Menu>

          </Box>}
        </Toolbar>
      </Container>
    </AppBar>
  );
}



export default ResponsiveAppBar;
